import './stylesheets/ExitButton.css';

function ExitButton(props) {
    const handleClick = () => {
        if (props.onExit) {
            props.onExit();
        }
    }

    return (
        <div id='ExitButton-container'>
            <div id="ExitButton" onClick={handleClick}>
                X
            </div>
        </div>
    );
}

export default ExitButton;
